const TOKEN_RE = /([?#&](?:token|code|ticket)=)[^&#\s"']+/gi;

/**
 * Blanks `token=<value>` (reset link, magic link), `code=<value>` (checkout
 * handoff code) and `ticket=<value>` (live chat socket URL) in text about to
 * leave the browser.
 */
export function redactToken(text: string): string {
  return text.replace(TOKEN_RE, "$1[redacted]");
}

/** `hash` without the magic link's `token=` or the checkout's `code=`; any other hash as is. */
export function hashWithoutToken(hash: string): string {
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  if (!params.has("token") && !params.has("code")) return hash;
  params.delete("token");
  params.delete("code");
  const rest = params.toString();
  return rest ? "#" + rest : "";
}
